export const disabledSendingCodeTime = 30 * 1000
